import firebase from 'firebase'

const app = firebase.initializeApp( {
  apiKey: "AIzaSyDxxkSlYKlKY8B9c8dvjwlZemexSexxbls",
  databaseURL: "https://twtr-cloud-traffic.firebaseio.com",
  projectId: "twtr-cloud-traffic",
});

export const db = app.database();


// WEBPACK FOOTER //
// ./src/config/firebase.js